import { generateClient } from 'aws-amplify/api';

const client = generateClient();

// Generate a random short code
const generateShortCode = (length = 6) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

// Create a short URL
export const createShortUrl = async (articleId) => {
  try {
    let shortCode;
    let isUnique = false;
    
    while (!isUnique) {
      shortCode = generateShortCode();
      const { data } = await client.models.ShortUrl.list({
        filter: {
          shortCode: {
            eq: shortCode
          }
        }
      });
      
      if (data.length === 0) {
        isUnique = true;
      }
    }

    // Store the full article path as originalUrl
    const originalUrl = `/article/${articleId}`;

    // Create the short URL record
    const result = await client.models.ShortUrl.create({
      shortCode,
      originalUrl,  // Store the full path
      articleId,
      clicks: 0,
      createdAt: new Date().toISOString()
    });

    return shortCode;
  } catch (error) {
    console.error('Error creating short URL:', error);
    throw error;
  }
};

// Get original URL from short code
export const getOriginalUrl = async (shortCode) => {
  try {
    const { data } = await client.models.ShortUrl.list({
      filter: {
        shortCode: {
          eq: shortCode
        }
      }
    });

    if (data.length === 0) {
      throw new Error('Short URL not found');
    }

    const shortUrl = data[0];

    // Increment click count
    await client.models.ShortUrl.update({
      id: shortUrl.id,  // Remove input wrapper
      clicks: (shortUrl.clicks || 0) + 1
    });

    // Return the stored path
    return shortUrl.originalUrl;
  } catch (error) {
    console.error('Error getting original URL:', error);
    throw error;
  }
}; 